import { ResultSet } from "@cubejs-client/core";

import { AppThunk } from "appThunk";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";
import { DateTime } from "luxon";

export class AverageDailyFootfall {
    public readonly retailCentreId: number;
    public readonly monthDate: DateTime;
    public readonly dayIndex: number;
    public readonly hourIndex: number;
    public readonly footfallCount: number;
    public readonly dwellTime: number;

    constructor(
        retailCentreId: number,
        monthDate: DateTime,
        dayIndex: number,
        hourIndex: number,
        footfallCount: number,
        dwellTime: number
    ) {
        this.retailCentreId = retailCentreId;
        this.monthDate = monthDate;
        this.dayIndex = dayIndex;
        this.hourIndex = hourIndex;
        this.footfallCount = footfallCount;
        this.dwellTime = dwellTime;
    }
}

export const loadAverageDailyFootfall = (retailCentreId: number | undefined): AppThunk<Promise<AverageDailyFootfall[]>> => async (dispatch) => {
    if (!retailCentreId) {
        return [];
    }
    const retailCentreIdString = retailCentreId.toString();
    try {
        // ToDo: Need to add date filter 
        const query = {
            dimensions: [
                "Footfall_RC_DayTime.RetailCentreID",
                "Footfall_RC_DayTime.MonthDate",
                "Footfall_RC_DayTime.DayIndex",
                "Footfall_RC_DayTime.HourIndex",
                "Footfall_RC_DayTime.FootfallCount",
                "Footfall_RC_DayTime.DwellTime"
            ],
            filters: [{
                member: "Footfall_RC_DayTime.RetailCentreID",
                operator: "equals",
                values: [retailCentreIdString]
            }]
        };

        const resultSet = await dispatch(cubeLoad(query)) as unknown as ResultSet;
        const rawData = resultSet.rawData();
        return rawData.map(row => new AverageDailyFootfall(
            Number(row["Footfall_RC_DayTime.RetailCentreID"]),
            DateTime.fromISO(row["Footfall_RC_DayTime.MonthDate"], { zone: "utc" }),
            Number(row["Footfall_RC_DayTime.DayIndex"]),
            Number(row["Footfall_RC_DayTime.HourIndex"]),
            Number(row["Footfall_RC_DayTime.FootfallCount"] ?? 0),
            Number(row["Footfall_RC_DayTime.DwellTime"] ?? 0)
        ));
    } catch (error) {
        dispatch(logError("Error loading AverageFootfall.", error));
        throw error;
    }
};
